export class FontList {
  fontList = [];
  names = [
    "Testing Name",
    "Agency FB",
    "Algerian",
    "Allura",
    "Amazone BT",
    "Arial",
    "Arial Rounded MT Bold",
    "Arial Unicode MS",
    "Avenir Black",
    "Bad Script",
    "Bahnschrift",
    "Baskerville Old Face",
    "Bell MT",
    "Berlin Sans FB",
    "Berlin Sans FB Demi",
    "Bernard MT Condensed",
    "Blackadder ITC",
    "Bodoni MT",
    "Book Antiqua",
    "Bookman Old Style",
    "Bradley Hand ITC",
    "Britannic Bold",
    "Broadway",
    "Brush Script MT",
    "Calibri",
    "Californian FB",
    "Calisto MT",
    "Calligrapher",
    "Cambria",
    "Candara",
    "Carter One",
    "Castellar",
    "Caveat",
    "Cedarville Cursive",
    "Centaur",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chaucer",
    "Chiller",
    "CloisterBlack BT",
    "Colonna MT",
    "Comic Sans MS",
    "Consolas",
    "Constantia",
    "Cookie",
    "Cooper Black",
    "Copperplate Bold",
    "Copperplate Light",
    "Corbel",
    "Coronet",
    "Courgette",
    "Courier",
    "Damascus Bold",
    "Dancing Script",
    "Dauphin",
    "Devanagari MT",
    "Didot",
    "East Sea Dokdo",
    "Ebrima",
    "Edwardian Script ITC",
    "Elephant",
    "English 111 Vivace BT",
    "Engravers MT",
    "Euphemia UCAS",
    "Farah Regular",
    "Felix Titling",
    "Footlight MT Light",
    "Forte",
    "Franklin Gothic Book",
    "Fransiscan",
    "Freestyle Script",
    "French Script MT",
    "Futura Bold",
    "Gabriola",
    "Gadugi",
    "Galvji",
    "Garamond",
    "Geneva",
    "Georgia",
    "Gigi",
    "Gill Sans MT",
    "Goudy Old Style",
    "Goudy Stout",
    "Great Vibes",
    "Haettenschweiler",
    "Harlow Solid Italic",
    "Harrington",
    "Helvetica",
    "Herculanum",
    "High Tower Text",
    "Hoefler Text",
    "HoloLens MDL2 Assets",
    "Homemade Apple",
    "Impact",
    "Imprint MT Shadow",
    "Informal Roman",
    "Ink Free",
    "Javanese Text",
    "Jester",
    "Jokerman",
    "Juice ITC",
    "Kailasa Regular",
    "Kaufmann BT",
    "Kaushan Script",
    "Kefa Regular",
    "Kenney Future Narrow",
    "Kristen ITC",
    "Kunstler Script",
    "Leelawadee UI",
    "Lemon",
    "Letterpress",
    "Lobster",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "Lucida Sans Typewriter",
    "Lucida Sans Unicode",
    "Luminari",
    "Marigold",
    "Marck Script",
    "Menlo Regular",
    "Monotype Corsiva",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MS Serif",
    "MS UI Gothic",
    "MV Boli",
    "Magneto",
    "Roboto",
    "Malgun Gothic",
    "Marlett",
    "Matura MT Script Capitals",
    "Microsoft Himalaya",
    "Microsoft JhengHei",
    "Microsoft New Tai Lue",
    "Microsoft PhagsPa",
    "Microsoft Sans Serif",
    "Microsoft Tai Le",
    "Microsoft YaHei",
    "Microsoft YaHei UI",
    "Microsoft Yi Baiti",
    "MingLiU-ExtB",
    "MingLiU HKSCS-ExtB",
    "Mistral",
    "Monaco",
    "Mongolian Baiti",
    "Monotype Corsiva",
    "Muna Regular",
    "Myanmar Text",
    "Nerko One",
    "NSimSun",
    "Niagara Engraved",
    "Niagara Solid",
    "Nirmala UI",
    "Nirmala UI Semilight",
    "OCR A Extended",
    "Old English Text MT",
    "Oleo Script",
    "Onyx",
    "Optima Regular",
    "PMingLiU-ExtB",
    "Palace Script MT",
    "Palatino",
    "Palatino Linotype",
    "Pacifico",
    "Papyrus",
    "Parchment",
    "Parisienne",
    "Permanent Marker",
    "Perpetua",
    "Perpetua Titling MT",
    "Playbill",
    "Poor Richard",
    "Pristina",
    "Raanana",
    "Rage Italic",
    "Ravie",
    "Ribbon 131 BD BT",
    "Roboto",
    "Rockwell",
    "Roman",
    "Sacramento",
    "Sathu",
    "Satisfy",
    "ShelleyBolante BT",
    "Sceptre",
    "Script",
    "Segoe MDL2 Assets",
    "Segoe Print",
    "Shadows Into Light",
    "Sherwood",
    "Showcard Gothic",
    "SimSun",
    "Sitka Banner",
    "Sitka Display",
    "Sitka Heading",
    "Sitka Small",
    "Sitka Subheading",
    "Sitka Text",
    "Skranji",
    "Small Fonts",
    "Snap ITC",
    "Snell Roundhand",
    "Socket",
    "Sofia",
    "Stencil",
    "Storybook",
    "Sylfaen",
    "Symbol",
    "Tahoma",
    "Tangerine",
    "Technical",
    "Tempus Sans ITC",
    "Texturina",
    "Times",
    "Times New Roman",
    "Thonburi",
    "Trebuchet MS",
    "Troika",
    "Tubular",
    "Tw Cen MT",
    "TypoUpright BT",
    "Unicorn",
    "Verdana",
    "Viner Hand ITC",
    "Vivaldi",
    "Vladimir Script",
    "Webdings",
    "Wide Latin",
    "Wingdings",
    "Yellowtail",
    "Yu Gothic",
    "Zantroke",
    "Zapf Dingbats",
    "Zapfino",
    "qtquickcontrols"
  ];

  constructor() {
    this.names.forEach((name) => {
      this.add(name, false);
    });
  }

  add(name, bool) {
    this.fontList.push(new Font(name, bool));
  }
}

export class Font {
  name: string = "";
  allowed: boolean = false;

  constructor(name: string, allowed: boolean) {
    this.name = name;
    this.allowed = allowed;
  }
}
